var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.143,
    height: 13.572,
    viewBox: "0 0 27.143 13.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_battery_std_24px",
    d: "M11.767,2.714H9.5V0H4.071V2.714H1.805A1.813,1.813,0,0,0,0,4.519V25.325a1.816,1.816,0,0,0,1.805,1.819h9.948a1.816,1.816,0,0,0,1.819-1.805V4.519A1.813,1.813,0,0,0,11.767,2.714Z",
    transform: "translate(27.143) rotate(90)",
    fill: "#4ca07a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryFull);
export default __webpack_public_path__ + "static/media/battery-full.71332bb623a3f401f2eecdff526462e0.svg";
export { ForwardRef as ReactComponent };